import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {RootState} from '../../../../../setup'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import {hasPermission} from '../../../../../_helper/hasPermission'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {permissions} from '../../../../../_constants/permissions'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {
  NOTES_COLUMNS_DATA_MAPPING,
  NOTES_LISTING_COLUMNS,
  NOTES_SORTING_COLUMNS,
} from '../../../caregiver/NOTES_TABLE_CONSTANTS'
import dayjs from 'dayjs'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import BackButton from '../../../../reusable-components/Buttons/BackButton'
const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedCaregiverAssessmentList = () => {
  const history = useHistory()
  const [filteredData, setFilteredData] = useState([])
  const [isFetchingData, setIsFetchingData] = useState(true)
  const timeZone = useSelector(selectTimeZone)
  const [searchTerm, setSearchTerm] = useState('')
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string, isDeleted: boolean = true) => {
      setIsFetchingData(true)
      try{
      const response = await axios.get(`/notes/getAll?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&isDeleted=${isDeleted}`)
      const { data, currentPage, totalCounts } = response.data;
        const updatedData = data.map((item) => ({
          ...item,
          creationDate: item.creationDate
            ? dayjs.utc(item.creationDate).tz(timeZone, true).format('MM-DD-YYYY')
            : 'No details provided',
        }))
        setFilteredData(updatedData)
        setQueryData((prevState) => {
            return {
                ...prevState,
                currentPage,
                totalCounts,
            };
        
        });} catch (error) {
          if (axios.isCancel(error)) {
            console.log('Request canceled', error.message)
          } else {
            console.log('Error: ', error.message)
          }
        } finally{
          setIsFetchingData(false)
        }
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, true)
  }, [queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir])

  const onView = (row) => {
    history.push(
      `/deleted-notes/caregiver-notes/notesEntries/${row._id}`
    )
  }

  const onUpdate = (row) => {
    history.push(`/deleted-notes/caregiver-notes/${row._id}`)
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Deleted Caregiver Assessments'></TableTitle>
        <TableWrapper
          searchField={
            hasPermission(userPermissions, permissions.care_giver_notes_note_search) && (
              <TableSearchBar
                label='Search'
                variant='outlined'
                size='small'
                value={searchTerm}
                setQueryData={setQueryData}
                setSearchTerm={setSearchTerm}
                margin='normal'
                inputAdornmentPosition='start'
              ></TableSearchBar>
            )
          }
          tableButtons={
            <>
              <BackButton />
            </>
          }
          dynamicTable={
            <>
              <span className='ml-2 text-primary d-flex align-items-center gap-2'>
                For view Caregiver notes please click on <VisibilityOutlinedIcon /> icon in the
                table
              </span>
              <DynamicTable
                htmlColumns={[]}
                columns={NOTES_LISTING_COLUMNS}
                data={filteredData}
                sortingColumns={NOTES_SORTING_COLUMNS}
                canView={hasPermission(userPermissions, permissions.care_giver_notes_note_view)}
                onView={onView}
                canUpdate={hasPermission(
                  userPermissions,
                  permissions.care_giver_notes_note_view
                )}
                onUpdate={onUpdate}
                setQueryData={setQueryData}
                queryData={queryData}
                columnDataMapping={NOTES_COLUMNS_DATA_MAPPING}
                tableLoader={isFetchingData}
              />
            </>
          }
        />
      </div>
    </div>
  )
}

export default DeletedCaregiverAssessmentList
